module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/forced-dropoff/forced-dropoff.component.css
// module id = ./src/app/forced-dropoff/forced-dropoff.component.css
// module chunks = main